import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Calendar, Users, UserCheck, Shield, Home } from 'lucide-react';

const OutingNavigation = ({ userRole }) => {
  const location = useLocation();

  const navigationItems = [
    {
      name: 'Home',
      href: '/dashboard',
      icon: Home,
      current: location.pathname === '/dashboard'
    }
  ];

  // Add role-specific navigation items
  if (userRole === 'student') {
    navigationItems.push({
      name: 'Student Portal',
      href: '/outing/student',
      icon: Calendar,
      current: location.pathname === '/outing/student'
    });
  } else if (userRole === 'parent') {
    navigationItems.push({
      name: 'Parent Portal',
      href: '/outing/parent',
      icon: Users,
      current: location.pathname === '/outing/parent'
    });
  } else if (userRole === 'staff') {
    navigationItems.push({
      name: 'Staff Portal',
      href: '/outing/staff',
      icon: UserCheck,
      current: location.pathname === '/outing/staff'
    });
  } else if (userRole === 'security') {
    navigationItems.push({
      name: 'Security Portal',
      href: '/outing/security',
      icon: Shield,
      current: location.pathname === '/outing/security'
    });
  }

  return (
    <nav className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-4">
            <img 
              src="/images/Logos/tac-logo.png" 
              alt="Academic City Logo" 
              className="h-10 w-auto"
            />
            <div className="hidden md:block">
              <div className="flex items-baseline space-x-4">
                {navigationItems.map((item) => {
                  const Icon = item.icon;
                  return (
                    <Link
                      key={item.name}
                      to={item.href}
                      className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                        item.current
                          ? 'bg-teal-100 text-teal-700'
                          : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                      }`}
                    >
                      <div className="flex items-center space-x-2">
                        <Icon className="h-4 w-4" />
                        <span>{item.name}</span>
                      </div>
                    </Link>
                  );
                })}
              </div>
            </div>
          </div>
          
          <div className="flex items-center space-x-4">
            <span className="text-sm text-gray-600">
              {userRole ? `${userRole.charAt(0).toUpperCase() + userRole.slice(1)} Portal` : 'Portal'}
            </span>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default OutingNavigation;
